import { render, staticRenderFns } from "./PrincipalUsuario.vue?vue&type=template&id=448022d3&scoped=true"
import script from "./PrincipalUsuario.vue?vue&type=script&lang=js"
export * from "./PrincipalUsuario.vue?vue&type=script&lang=js"
import style0 from "./PrincipalUsuario.vue?vue&type=style&index=0&id=448022d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448022d3",
  null
  
)

export default component.exports